module.exports = __webpack_public_path__ + "static/img/bg4@2x.7e2147b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/bg4@2x.png
// module id = qGKY
// module chunks = 2